import GlobeIcon from 'components/Icons/GlobeIcon';
import { IconButton } from 'components/lib';
import { MapboxStyles } from 'constants/map';
import React, { FC } from 'react';
import ToggleMenu from './ToggleMenu';

type MapViewTypeToggleProps = {
  id?: string;
  includeNoMap?: boolean;
  mapStyle: MapboxStyles;
  mapPosition: MapPosition;
  onStyleChange: (nextStyle: MapboxStyles) => void;
  showMenu: boolean;
  toggleMenu: VoidFunction;
};

type MapPosition = {
  top?: number | string;
  right?: number | string;
  bottom?: number | string;
  left?: number | string;
};

const MapViewTypeToggle: FC<MapViewTypeToggleProps> = ({
  id,
  includeNoMap = false,
  mapPosition,
  mapStyle,
  onStyleChange,
  showMenu,
  toggleMenu,
}: MapViewTypeToggleProps) => {
  return (
    <>
      {showMenu && (
        <ToggleMenu
          id={id}
          mapStyle={mapStyle}
          onStyleChange={onStyleChange}
          includeNoMap={includeNoMap}
          closeMenu={toggleMenu}
          style={{ left: mapPosition.left }}
        />
      )}

      <IconButton
        id={`${id}-type`}
        aria="toggle map type"
        onClick={toggleMenu}
        type="button"
        size="large"
        variant="fab"
        css={{
          position: 'absolute',
          bottom: '32px',
          left: '132px',
          ...mapPosition,
        }}
      >
        <GlobeIcon />
      </IconButton>
    </>
  );
};

export default MapViewTypeToggle;
